import { render } from "./yuyueDepart.vue?vue&type=template&id=5f3fdf80"
import script from "./yuyueDepart.vue?vue&type=script&lang=js"
export * from "./yuyueDepart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__